import React from 'react';
import { useTabsContext } from './TabsContext';
function TabPanel({ children, value, className, }) {
    const [tab] = useTabsContext();
    return tab === value ? (React.createElement("article", { className: className, role: "tabpanel", "aria-hidden": "false" }, children)) : null;
}
export default TabPanel;
//# sourceMappingURL=TabPanel.js.map